import { ButtonStyled } from "../Button/styled";
import { ErrorWrapper, Message, StyledError } from "./styled";

export const Error = () => (
    <ErrorWrapper>
        <Message>
            Coś poszło nie tak <br />
            Sprawdź połączenie z internetem!
        </Message>
        <StyledError />
        <ButtonStyled>Spróbój ponownie</ButtonStyled>
    </ErrorWrapper>
);